var styleDataHash = '88a595c7';  
export const injectCss = (() => {
  var css = `.w7yUM{display:block;height:100%;width:100%}.w7yUM img{max-width:var(--wix-img-max-width,100%)}.w7yUM[data-animate-blur] img{filter:blur(9px);transition:filter .8s ease-in}.w7yUM[data-animate-blur] img[data-load-done]{filter:none}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "image": "w7yUM"
};